import { useAuth0 } from "@auth0/auth0-react";
import {
  Route,
  RouteProps,
  Redirect,
  RouteChildrenProps,
} from "react-router-dom";
import Loading from "views/Loading";
import { appConfig } from "env-config";
import { decodeToken } from "react-jwt";
import { TokenProps } from "providers/Settings/UserAuthProvider";

interface ProtectedRouteProps extends RouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children, ...rest }: ProtectedRouteProps) => {
  const { isLoading, isAuthenticated, user } = useAuth0();
  const { path } = rest;
  const clientId = appConfig.REACT_APP_AUTH0_CLIENT_ID;
  const audience = appConfig.REACT_APP_AUTH0_AUDIENCE;
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  );

  const decodedToken = decodeToken(userInfos?.body.access_token) as TokenProps;
  if (isLoading) {
    return <Loading />;
  }

  // if (decodedToken.role === undefined) {
  //   logout({ returnTo: window.location.origin });
  // }
  return (
    <Route
      {...rest}
      render={(routeProps: RouteChildrenProps<{ [x: string]: string }>) =>
        isAuthenticated ? (
          path.toString().substring(1) === "" ? (
            children
          ) : decodedToken?.role?.toLocaleLowerCase() ===
            path.toString().substring(1) ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/",
                state: { from: routeProps.location },
              }}
            />
          )
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: routeProps.location },
            }}
          />
        )
      }
    />
  );
};
